import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { EasypayImportErrorFile } from './easypay-import-error-file.interface';
import { EasypayImportErrorFileService } from './easypay-import-error-file.service';

const service = new EasypayImportErrorFileService();

export interface EasypayImportErrorFileState {}

const EasypayImportErrorFileStore: Module<EasypayImportErrorFileState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {},
   actions: {
      async postEasypayImportErrorFile(context, errorFile: EasypayImportErrorFile) {
         const batch = await service.postEasypayImportErrorFile(errorFile);
         context.commit('batch/ADD_BATCH', batch, { root: true });
         return batch;
      },
   },
};

export default EasypayImportErrorFileStore;
